(function($){
        
	// Add Loaded Class
	$('.ptx-formselect').addClass('ptx-formselect--loaded');
  
})(jQuery);